import api from './api';

function normalizeStudent(raw) {
  const id = raw?.studentId || raw?.student_Id || raw?.Student_Id || raw?.id || null;
  return {
    id: id != null ? String(id) : null,
    firstName: raw?.firstName || raw?.student_First_Name || raw?.Student_First_Name || '',
    lastName: raw?.lastName || raw?.student_Last_Name || raw?.Student_Last_Name || '',
    dateOfBirth: raw?.dateOfBirth || raw?.student_Date_Of_Birth || raw?.Student_Date_Of_Birth || '',
    gender: raw?.gender || raw?.student_Gender || raw?.Student_Gender || '',
    relationship: raw?.relationship || raw?.student_Relationship || raw?.Student_Relationship_To_User || raw?.Student_Relationship || ''
  };
}

export async function fetchStudentsForUser(userId) {
  const response = await api.get(`/EventChannel/GetStudents?userId=${userId}`);
  const data = response.data;
  const list = Array.isArray(data?.students) ? data.students : Array.isArray(data) ? data : [];
  return list.map(normalizeStudent).filter((s) => s.id);
}
